import { defaultApi } from 'api';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { TenantsApi } from 'modules/application/api';
import { applicationLanguageState } from 'modules/application/atoms';
import React, { useEffect, useState } from 'react';
import { IntlProvider } from 'react-intl';
import { useRecoilValue } from 'recoil';
import { defaultLocale, i18nMessages } from 'utils/locales';
import dayjs from 'dayjs';
import 'dayjs/locale/fr-ca';
import 'dayjs/locale/en-ca';
import utc from 'dayjs/plugin/utc';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(relativeTime);
dayjs.extend(timezone);
dayjs.extend(localizedFormat);
dayjs.extend(utc);

interface Props {
  children?: React.ReactNode;
}

export const ConnectedIntlProvider: React.FC<Props> = ({ children }) => {
  const currentUserLocale = useRecoilValue(applicationLanguageState);
  const [messages, setMessages] = useState(i18nMessages[currentUserLocale]);

  defaultApi.defaults.headers.common['accept-language'] = currentUserLocale;
  dayjs.locale(currentUserLocale.toLowerCase());

  useEffect(() => {
    TenantsApi.getI18n().then(customMessages => {
      const defaultMessages = i18nMessages[currentUserLocale];

      if (defaultMessages) {
        Object.entries(defaultMessages).forEach(entry => {
          if (!customMessages[entry[0]]) {
            customMessages[entry[0]] = entry[1];
          }
        });
      }

      setMessages(customMessages);
    });
  }, [currentUserLocale, setMessages]);

  return (
    <IntlProvider
      locale={currentUserLocale}
      messages={messages}
      defaultLocale={defaultLocale}
      key={currentUserLocale}
    >
      {children}
    </IntlProvider>
  );
};
